export const checkHasRoles = (userRoles, roles, mustHaveAll = true) => {
  if (userRoles.includes('admin')) return true;
  if (mustHaveAll) return roles.every(role => userRoles.includes(role));
  return roles.some(role => userRoles.includes(role));
};

